/* eslint-disable @typescript-eslint/no-explicit-any */

export type StartingTriggerOperator = "equal" | "notEqual";
export type StateTriggerOperator = "and" | "or";

export interface StateTriggers<T>
{
    startingTriggers: StartingTrigger<T>[];
    operator: StateTriggerOperator;
    setValueStatePaths?: string[];
    setObjectStatePaths?: string[];
    toValue: T;
}

export interface StartingTrigger<T>
{
    statePath: string;
    operator: StartingTriggerOperator;
    value: T;
}


export default {
    stateTriggers: [
        {
            startingTriggers: [
                {
                    statePath: "Window.TimeoutWarning.visible",
                    operator: "equal",
                    value: true,
                },
                {
                    statePath: "Survey.visible",
                    operator: "equal",
                    value: true,
                },
                {
                    statePath: "Window.InputBoxLocked.isInputBoxLocked",
                    operator: "equal",
                    value: true,
                },
            ],
            operator: "or",
            setValueStatePaths: [
                "Window.AlmeMessage.shouldDisable",
                "Window.DisplayLinks.shouldDisable",
                "Window.DisplayLinksUrl.shouldDisable",
                "Window.InputBoxLocked.isInputBoxLocked",
                "Window.NavUrl.shouldDisable",
                "Window.SkipToContent.shouldDisable",
                "Window.UserMessage.shouldDisable",
                "Window.Accordion.shouldDisable",
            ],
            setObjectStatePaths: [
                "Window.CallToActionButtons.shouldDisable",
                "Window.InlineSurveyLinks.shouldDisable",
            ],
            toValue: true,
        },
        {
            startingTriggers: [
                {
                    statePath: "Window.TimeoutWarning.visible",
                    operator: "notEqual",
                    value: true,
                },
                {
                    statePath: "Survey.visible",
                    operator: "notEqual",
                    value: true,
                },
                {
                    statePath: "Window.InputBoxLocked.isInputBoxLocked",
                    operator: "notEqual",
                    value: true,
                },
            ],
            operator: "and",
            setValueStatePaths: [
                "Window.AlmeMessage.shouldDisable",
                "Window.DisplayLinks.shouldDisable",
                "Window.DisplayLinksUrl.shouldDisable",
                "Window.InputBoxLocked.isInputBoxLocked",
                "Window.NavUrl.shouldDisable",
                "Window.SkipToContent.shouldDisable",
                "Window.UserMessage.shouldDisable",
                "Window.Accordion.shouldDisable",
            ],
            setObjectStatePaths: [
                "Window.CallToActionButtons.shouldDisable",
                "Window.InlineSurveyLinks.shouldDisable",
            ],
            toValue: false,
        },
    ] as StateTriggers<unknown>[],
};



// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/settings/state-triggers.ts